import GeoJSON from 'ol/format/GeoJSON'
const formater_ = new GeoJSON()
const GeoJsonUtil = {
  readFeature(geojson) {
    let feature = null
    try{
      feature = formater_.readFeature(geojson)
    }catch(e){
      console.error("GeoJson to feature error:",e.message,geojson);
    }
    return feature
  },
  readFeatures(geojson) {
    let features = null
    try{
      features = formater_.readFeatures(geojson)
    }catch(e){
      console.error("GeoJson to features error:",e.message,geojson);
    }
    return features
  },
  writeFeature(feature) {
    return formater_.writeFeature(feature)
  },
  writeFeatures(features) {
    return formater_.writeFeatures(features)
  },
}
export default GeoJsonUtil
